<div class="p-4">
  <div class="rounded-lg p-1">
    <!-- Company First Card with side margins -->
    <div class="company-first-card mb-4 shadow-lg rounded-lg w-100 px-3 py-2 position-relative" :class="{
    'complyon-bg': hostname.includes('aicampus.complyon') ,
     }">
      <section class="hero-section w-100 px-2 py-1 d-flex justify-content-between align-items-start">

        <!-- Hero content on left -->
        <div class="hero-content p-1 me-5 col-md-7 col-lg-6">
          <p class="hero-title text-white text-xl fw-bold mt-4">
            All Your Applications, In One Place
          </p>
          <p class="hero-description mt-1 text-white text-x">
           Stay on top of submissions and next steps.
          </p>
        </div>
      </section>
      <div class="d-flex gap-2 justify-content-md-end mt-5">
            <!-- for buttons -->
      </div>
    </div>

    <div>
      <!-- Table Card - Responsive by default -->
      <div class="d-flex justify-content-end align-items-center mb-3">
      </div>

      <div class="shadow-lg glassy-table rounded-lg p-3 text-xs">
        <GlobalTable
          :key="table_render_key"
          :headers="application_table_headers"
          :data="table_safe_application_list"
          table_id="entity_form_management_table"
        >
          <template #actions="{ row }">
            <button
              class="btn btn-primary-dark btn-sm rounded-small shadow text-dark ms-1 text-xxs"
              @click="view_entity_application_overview(row)"
            >
              View
            </button>
          </template>
        </GlobalTable>
      </div>
    </div>
  </div>

  <!-- Footer -->
  <AICampusFooter/>
</div>

